import { propertiesOf } from "utils/propertyOf";
import { EntityRef } from "utils/rest/entities";
import { ImageDto } from "./image";
import { Coin } from "./coin";

export enum BranchAuthenticationType {
  NONE = "NONE",
  PERSONAL_DATA = "PERSONAL_DATA",
  KYC = "KYC",
  BLOCKCHAIN = "BLOCKCHAIN",
}

export const exposesPersonalData = (branch: Branch | undefined): boolean =>
  branch?.authenticationType === BranchAuthenticationType.PERSONAL_DATA ||
  branch?.authenticationType === BranchAuthenticationType.KYC;

/** Mirrors key2-server's [com.kurzdigital.key2.key2server.dto.BranchDto] */
export interface Branch extends EntityRef {
  id: number;
  name: string;
  abbreviation: string;
  contact: string | null;
  coin: Coin | null;
  style: BranchStyle | null;
  authenticationType: BranchAuthenticationType;
}

export interface BranchStyle {
  id: number;
  highlightColor: string;
  backgroundColor: string;
  logoImage: ImageDto | null;
  backgroundImage: ImageDto | null;
}

export const ofBranch = propertiesOf<Branch>();

export const ofBranchStyle = propertiesOf<BranchStyle>();

export const defaultBranchStyle: BranchStyle = {
  id: 0,
  highlightColor: "#333333",
  backgroundColor: "#666666",
  logoImage: null,
  backgroundImage: null,
};

export const defaultBranch: Branch = {
  id: 0,
  name: "",
  abbreviation: "",
  contact: "",
  coin: null,
  style: defaultBranchStyle,
  authenticationType: BranchAuthenticationType.NONE,
};
